import React from 'react';

import ImagePreview from './Image';

import * as styled from './styles';
import { navigate } from 'gatsby';

const getSlug = (type, slug) => {
  switch (type) {
    case 'story':
      return `/stories/${slug}`;
    case 'gallery':
      return `/gallery/${slug}`;
    case 'featured':
      return slug;
    case 'pages':
      return slug;
    default:
      return slug;
  }
}

const SearchHit = ({ hit, suppressLabel }) => {
  const {
    type,
    subtype: category,
    date,
    title,
    image,
    slug,
    description,
    __position: hitIndex,
    ...rest
  } = hit;
  const properSlug = getSlug(type, slug);

  // if (type === 'horizon') return null;

  const layoutProps = hitIndex > 3 ? { type: 'column', size: 'small'} : { type: 'card'};

  return (
      <styled.CardInner
        alignStart={false}
        key={hitIndex}
      >
        <ImagePreview
          suppressLabel={suppressLabel}
          category={category}
          date={date}
          excerpt={description?.en}
          title={title?.en}
          heroImage={{
            asset: {
              fluid: hit.image,
            },
          }}
          selectCategory={(slug) => {
            navigate(`/stories${slug}`);
          }}
          size={layoutProps.size}
          slug={properSlug}
          type={layoutProps.type}
          itemType={type}
      />
      </styled.CardInner>
  )

}

export default SearchHit;
